import { atom } from "recoil";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export const questionsAtom = atom<any>({
  key: RecoilKeys.Questions,
  default: [],
});
